export const createFormData = (data: { [key: string]: any }, arrayItems: string[] = []) => {

  var form_data = new FormData();

  var key: string

  for (key in data) {
    if (typeof data[key] != 'undefined' && !!data[key] && arrayItems?.indexOf(key) == -1) {


      if (typeof data[key] == 'object' && Array.isArray(data[key]))
        form_data.append(key, JSON.stringify(data[key]));

      else if (!Array.isArray(data[key]))
        form_data.append(key, data?.[key] as any);
    }
  }

  arrayItems?.forEach(item => {
    if (Array.isArray(data[item]))
      data[item].forEach((f: string | Blob) => form_data.append(item, f))
  })


  return form_data
}

export const isFileImage = (src: string) => !['jpg', 'jpeg', 'png', 'gif', 'bmp', 'svg', 'webp', 'tiff', 'heic', 'heif'].every(i => !src.split('.').reverse()[0].toLowerCase().includes(i.toLowerCase()) && !src.split('/').reverse()[0].toLowerCase().includes(i.toLowerCase()))

export const getRemainingTime = (date: string): {
  day: number,
  hour: number,
  minute: number,
  isPassed: boolean
} => {

  const oneDay = 24 * 60 * 60 * 1000; // hours*minutes*seconds*milliseconds
  const oneHour = 60 * 60 * 1000
  const oneMinute = 60 * 1000
  const firstDate = new Date(date.split(' ')[0]);
  firstDate.setHours(0, 0, 0, 0)
  const secondDate = new Date();


  const diffDays = Math.ceil((firstDate.getTime() - secondDate.getTime()) / oneDay);
  const diffHours = Math.ceil((firstDate.getTime() - secondDate.getTime() - (diffDays * oneDay)) / oneHour);
  const diffMinute = Math.ceil((firstDate.getTime() - secondDate.getTime() - (diffDays * oneDay) - (diffHours * oneHour)) / oneMinute)

  return ({ day: Math.abs(diffDays), hour: Math.abs(diffHours), minute: Math.abs(diffMinute), isPassed: firstDate.getTime() <= secondDate.getTime() })


}

export const createFileURL = (link: string) => {

  if (!link)
    return ''

  if (link.includes('storage'))
    return `${process.env.REACT_APP_PUBLIC_URL?.replace('/api/v1/','')}${link}`

  return `${process.env.REACT_APP_PUBLIC_URL?.replace('/api/v1/','')}/storage${link}`
}